import React, { useCallback, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Section } from "./Section";
import { SelectTemplate } from "./SelectTemplate";

import { changeRate } from "../../../../../../store/modules/audio/actions";
import { getRate } from "../../../../../../store/modules/audio/selectors";

import { VALUES } from "../../../../../constants/speed";

import { rateToValue, valueToRate } from "../../../../../../utils/converSpeed";

export const SpeedControl: React.FC = () => {
  const dispatch = useDispatch();
  const rate = useSelector(getRate);
  const currentSpeed = useMemo(() => rateToValue(rate).toString(), [rate]);
  const options = useMemo(() => {
    const values = [...VALUES];
    const currentValue = rateToValue(rate);

    if (!values.includes(currentValue)) {
      values.push(currentValue);
      values.sort((a, b) => a - b);
    }

    return values.map(item => ({ value: `${item}`, label: `${item} WPM` }));
  }, [rate]);

  const handleOnChange = useCallback((value: string) => {
    dispatch(changeRate(valueToRate(parseInt(value))));
  }, [dispatch]);

  return (
    <Section mt="10px">
      <SelectTemplate
        title="Default Speed"
        value={currentSpeed}
        options={options}
        handleOnChange={handleOnChange}
      />
    </Section>
  );
};
